// The prototype's icon for each access policy and each permission.

export const POLICY_ICON = {
  entire_brand: "map",
  selected_regions: "map",
  one_region: "map",
  selected_dealers: "bld",
  selected_workshops: "wrench",
  one_workshop: "wrench",
  assigned_customers: "people",
};

export const PERMISSION_ICON = {
  advisors_desk: "head",
  chat_audit: "chat",
  book_service: "plus",
  workshop_analytics: "trend",
  manage_regions: "map",
  manage_dealers: "bld",
  manage_workshops: "wrench",
  manage_roles: "shield",
  manage_people: "people",
};
